import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import TemplatesACHPage, { getDefaultData, getDefaultUI } from "components/pages/TemplatesACHPage";
import Classes, { ACHTemplate, ACHToParticipant, Company, CompanyAccount, NonNachaParticipants, Participant } from "model";

/**
 * @name CaptureTemplateAdded
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "ACH - ImportFile (Non-NACHA)" (abi22).
 */
export default function CaptureTemplateAdded(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    let nextParticipantId = Participant.nextID();
    const nonNachaParticipants = NonNachaParticipants.initAll().reduce((acc, item) => {
        const added = Participant.init({
            ...item.record,
            id: nextParticipantId,
        });

        nextParticipantId = parseFloat(nextParticipantId) + 1
        acc.push(added);

        return acc;
    }, []);

    let nextACHToParticipantId = ACHToParticipant.nextID();
    const achToParticipants = nonNachaParticipants.reduce((acc, item) => {
        const added = ACHToParticipant.init({
            id: nextACHToParticipantId,
            participant: Participant.init({ ...item.record, isSelected: "true" }),
            notify: "No",
            addenda: "0",
            numberOfDistributions: "1",
            amount: "1.00"
        });

        nextACHToParticipantId = parseFloat(nextACHToParticipantId) + 1
        acc.push(added);

        return acc;
    }, []);

    const selectedTemplate = ACHTemplate.init({
        id: ACHTemplate.nextID(),
        transactionType: "payment",
        secCode: "PPD Credit - Consumer Credit",
        name: "SamplePPD",
        companyDiscretionaryData: "",
        companyEntryDescription: "Payroll",
        creditAmount: "3.00",
        debitAmount: "3.00",
        achToParticipants: achToParticipants,
        achFromAccount: [],
        company: Company.initByID(0),
        companyAccount: CompanyAccount.initByID(0),
        numberOfAccounts: "1"
    });

    const achTemplates = ACHTemplate.initAll()
    let mergeAchTemplates = [ selectedTemplate ];

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update(["achTemplates"], mergeAchTemplates)
    .update([ "createdTemplate" ], selectedTemplate)
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update(["showCreatedACHTemplateBanner"], true)
    .update([ "searchOptions", "show" ], false)
    .update([ "addTemplateButton", "show" ], false)
    .submit();

    return <TemplatesACHPage data={ data } ui={ ui } className="for-capture"/>;
}